import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Add2"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.58333 1.5C8.85948 1.5 9.08333 1.72386 9.08333 2L9.083 6.9165L14 6.91667C14.2761 6.91667 14.5 7.14052 14.5 7.41667V8.58333C14.5 8.85948 14.2761 9.08333 14 9.08333L9.083 9.083L9.08333 14C9.08333 14.2761 8.85948 14.5 8.58333 14.5H7.41667C7.14052 14.5 6.91667 14.2761 6.91667 14L6.9165 9.083L2 9.08333C1.72386 9.08333 1.5 8.85948 1.5 8.58333V7.41667C1.5 7.14052 1.72386 6.91667 2 6.91667L6.9165 6.9165L6.91667 2C6.91667 1.72386 7.14052 1.5 7.41667 1.5H8.58333Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var add_2 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { add_2 as default };
